<template>
  <div>
    <h3 class="title">検索条件</h3>
    <ValidationObserver ref="observer" tag="form">
      <table class="table">
        <tbody>
          <tr v-if="isDisplay('enterpriseCode')">
            <td>企業コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="numeric|digits:16">
                <input type="text" id="enterpriseCode" :name="itemName.enterpriseCode" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="enterpriseCode" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>拠点コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="alpha_num|max:16">
                <input type="text" id="sectionCode" :name="itemName.sectionCode" class="form-control enterp-codeInput"
                autocomplete="off" v-model="sectionCode" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>ユーザID</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="alpha_num|min:8|max:16">
                <input type="text" id="userId" :name="itemName.userId" class="form-control enterp-codeInput"
                autocomplete="off" v-model="userId" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
        </tbody>
      </table>
    </ValidationObserver>
    <RfidButton :display="'inline'" @handleClick="search">検索</RfidButton>
    <router-link :to="{ name: 'user-edit-new', params: { mode: 'entry' }}"
      class="btn btn-primary btn-lg w200" role="button" aria-pressed="true">新規追加</router-link>
    <br><br>
  </div>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'enterprise-search-window',

  components: {
    ValidationObserver,
    ValidationProvider,
    RfidButton
  },

  data () {
    return {
      enterpriseCode: '',
      sectionCode: '',
      userId: '',
      permissionData: {},
      itemName: {}
    }
  },

  created () {
    this.permissionData = this.permission().userList['entry']
    this.itemName = this.item()
  },

  methods: {
    isDisplay (item) {
      return this.permissionData[item][this.$session.get('userDiv')] !== 'displayNone'
    },
    async search () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('search', this.enterpriseCode, this.sectionCode, this.userId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/UserSearchWindow.vue